import React, {useState, useEffect, useContext} from "react";
import {functions} from "../../constants/common-functions";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import AmChartSimpleColumn from "../../components/AmChartSimpleColumn";
import AmChartSimpleBar from "../../components/AmChartSimpleBar";;
import DashboardToolPanel from "../../components/DashboardToolPanel";
import {COLOR_UTILISATION_VACANT} from "../../constants/colors";
import UtilityDashboardLayout from "../../components/dashboardlayouts/UtilityDashboardLayout";
import {utilityDashboardComponentContainer} from "../../constants/styles";
import ChartCardLarge from "../../components/ChartCardLarge";
import {store} from '../../context/store';

export default function UtilisationUnusedDesks(){
	
	const [data1, setData1] = useState([]);
	const [data2, setData2] = useState([]);
	const [data3, setData3] = useState([]);
	const [data4, setData4] = useState([]);
	const [data5, setData5] = useState([]);
	const [data6, setData6] = useState([]);
	const [data7, setData7] = useState([]);
	const [dataIndex, setDataIndex] = useState(0);
	
	const [displayByDate, setDisplayByDate] = useState("flex");
	const [displayByParentSpaceType, setDisplayByParentSpaceType] = useState("none");
	const [displayBySpaceType, setDisplayBySpaceType] = useState("none");
	const [displayByParentOrganisation, setDisplayByParentOrganisation] = useState("none");
	const [displayByOrganisation, setDisplayByOrganisation] = useState("none");
	const [displayTopBottom, setDisplayTopBottom] = useState("none");
	
	const [facilityId, setFacilityId] = useState("-100");
	
	const [loaded, setLoaded] = useState(false);

	const globalState = useContext(store);
			
		const utilisationSurveyId =
		    globalState?.state?.queryContext?.utilisationSurveyId ?? null;
	
	useEffect(() => {
		if(loaded === false){
			loadData(dataIndex);
			setLoaded(true);
		}
	
		
		
	}, [dataIndex, utilisationSurveyId]);
	
	const loadData = (dataIndex) => {
		switch(dataIndex) {
		  case 0:
		    loadData1();
		    break;
		  case 1:
		    loadData2();
		    break;
		  case 2:
		    loadData3();
		    break;
		  case 3:
		    loadData4();
		    break;
		   case 4:
		    loadData5();
		    break;
		   case 5:
		    loadData6();
		    loadData7();
		    break;
		  default:
		    loadData1();
		}
	};

	
	const loadData1 = () => {
		
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetdailyunuseddesksbydate?utilisationSurveyId=" + utilisationSurveyId, setData1, handleData1);
	};
	
	
	const handleData1 = (results) => {
	   const tempData = results.map(({groupBy, returnDouble }) => ({
	    id:groupBy,
	    label:groupBy,
	    value:returnDouble
	  }));
	  setData1(tempData);
	};
	
	const loadData2 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetdailyunuseddesksbyparentspacetype?utilisationSurveyId=" + utilisationSurveyId, setData2, handleData2);
	};
	
	
	const handleData2 = (results) => {
		
	 const tempData = results.map(({id, code, name, value }) => ({
	    id:id,
	    label:name,
	    value,
	  }));
	  
	  setData2(tempData);
	};
	
	const loadData3 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetdailyunuseddesksbyspacetype?utilisationSurveyId=" + utilisationSurveyId, setData3, handleData3);
	};
	
	
	const handleData3 = (results) => {
		
	 const tempData = results.map(({id, code, name, value }) => ({
	    id:id,
	    label:name,
	    value,
	  }));
	  
	  setData3(tempData);
	};
	
	const loadData4 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetdailyunuseddesksbyparentorganisation?utilisationSurveyId=" + utilisationSurveyId, setData4, handleData4);
	};
	
	
	const handleData4 = (results) => {
		
	 const tempData = results.map(({id, code, name, value }) => ({
	    id:id,
	    label:name,
	    value,
	  }));
	  
	  setData4(tempData);
	};
	
	const loadData5 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetdailyunuseddesksbyorganisation?utilisationSurveyId=" + utilisationSurveyId, setData5, handleData5);
	};
	
	
	const handleData5 = (results) => {
		
	 const tempData = results.map(({id, code, name, value }) => ({
	    id:id,
	    label:name,
	    value,
	  }));
	  
	  setData5(tempData);
	};
	
	
	
	const loadData6 = () => {
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetdailyunuseddeskstop?utilisationSurveyId=" + utilisationSurveyId, setData6, handleData6);
	};
	
	const handleData6 = (results) => {
		const tempData = results.map(({id, code, name, value }) => ({
	    id:id,
	    label:code,
	    value,
	  }));
	  setData6(tempData);
	};
	
	const loadData7 = () => {
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetdailyunuseddesksbottom?utilisationSurveyId=" + utilisationSurveyId, setData7, handleData7);
	};
	
	const handleData7 = (results) => {
		const tempData = results.map(({id, code, name, value }) => ({
	    id:id,
	    label:code,
	    value,
	  }));
	  
	  setData7(tempData);
	};
  
 
	const refreshFunction = () => {
		loadData(dataIndex);
	};
	
 	
 	const resetDisplay = (index) => {
 		setDataIndex(index);
 		loadData(index);
 		setDisplayByDate("none");
 		setDisplayByParentOrganisation("none");
 		setDisplayByOrganisation("none");
 		setDisplayByParentSpaceType("none");
 		setDisplayBySpaceType("none");
 		setDisplayTopBottom("none");
 	};
 	
 	const showByDate = () => {
 		resetDisplay(0);
 		setDisplayByDate("flex");
 	};
 	
 	const showByParentSpaceType = () => {
 		resetDisplay(1);
 		setDisplayByParentSpaceType("flex");
 	};
 	
 	const showBySpaceType = () => {
 		resetDisplay(2);
 		setDisplayBySpaceType("flex");
 	};
 	
 	const showByParentOrganisation = () => {
 		resetDisplay(3);
 		setDisplayByParentOrganisation("flex");
 	};
 	
 	const showByOrganisation = () => {
 		resetDisplay(4);
 		setDisplayByOrganisation("flex");
 	};
 	
 	const showTopBottom = () => {
 		resetDisplay(5);
 		setDisplayTopBottom("flex");
 	};
 	
 	
 	const toolActions =[
		{label:'Unused (All Day) By Date', actionFunction:showByDate},
		{label:'By Parent Space Type', actionFunction:showByParentSpaceType},
		{label:'By Space Type', actionFunction:showBySpaceType},
		{label:'By Parent Organisation', actionFunction:showByParentOrganisation},
		{label:'By Organisation', actionFunction:showByOrganisation},
		{label:'Top/Bottom', actionFunction:showTopBottom}
	];
	
 	
	return (
		<UtilityDashboardLayout
		    title="Unused (All Day) Workplaces"
		    childDashboards={childDashboardsUtilisation}
		    refreshFunction={refreshFunction}
		  >
		  <div style={{...utilityDashboardComponentContainer, display:displayByDate}}>
		  	<ChartCardLarge title="Unused (All Day) By Date">
		  		<AmChartSimpleColumn
				 	chartId="utilisationunusedchart1"
				 	chartData={data1}
				 	categoryKey="label"
				 	valueKey="value"
				 	color={COLOR_UTILISATION_VACANT}
				 	width="100%"
				 	height="calc(100% - 0px)"
				/>
		  	  </ChartCardLarge>					
		  	</div>
		  	<div style={{...utilityDashboardComponentContainer, display:displayByParentSpaceType}}>
				<ChartCardLarge title="Unused (All Day) By Parent Space Type">
					<AmChartSimpleColumn
					 	chartId="utilisationunusedchart2"
					 	chartData={data2}
					 	categoryKey="label"
					 	valueKey="value"
					 	color={COLOR_UTILISATION_VACANT}
					 	width="100%"
					 	height="calc(100% - 0px)"
					/>
			  	  </ChartCardLarge>								
		  	</div>
		  	<div style={{...utilityDashboardComponentContainer, display:displayBySpaceType}}>
				<ChartCardLarge title="Unused (All Day) By Space Type">
					<AmChartSimpleColumn
					 	chartId="utilisationunusedchart3"
					 	chartData={data3}
					 	categoryKey="label"
					 	valueKey="value"
					 	color={COLOR_UTILISATION_VACANT}
					 	width="100%"
					 	height="calc(100% - 0px)"
					/>
			  	  </ChartCardLarge>	
			</div>
		  									
		  	<div style={{...utilityDashboardComponentContainer, display:displayByParentOrganisation}}>
				<ChartCardLarge title="Unused (All Day) By Parent Organisation">
					<AmChartSimpleColumn
					 	chartId="utilisationunusedchart4"
					 	chartData={data4}
					 	categoryKey="label"
					 	valueKey="value"
					 	color={COLOR_UTILISATION_VACANT}
					 	width="100%"
					 	height="calc(100% - 0px)"
					/>
			 	</ChartCardLarge>	
			</div>						
		  	<div style={{...utilityDashboardComponentContainer, display:displayByOrganisation}}>
				<ChartCardLarge title="Unused (All Day) By Organisation">
					<AmChartSimpleColumn
					 	chartId="utilisationunusedchart5"
					 	chartData={data5}
					 	categoryKey="label"
					 	valueKey="value"
					 	color={COLOR_UTILISATION_VACANT}
					 	width="100%"
					 	height="calc(100% - 0px)"
					/>
				</ChartCardLarge>	
		  	</div>			
		  	<div style={{...utilityDashboardComponentContainer, display:displayTopBottom}}>
				<ChartCardLarge title="Unused (All Day) Top">
					<AmChartSimpleBar
					 	chartId="utilisationunusedchart6"
					 	chartData={data6}
					 	categoryKey="label"
					 	valueKey="value"
					 	color={COLOR_UTILISATION_VACANT}
					 	width="100%"
					 	height="calc(100% - 0px)"
					/>
				</ChartCardLarge>						
		  	</div>									
		  											
			<div style={{...utilityDashboardComponentContainer, display:displayTopBottom}}>
				<ChartCardLarge title="Unused (All Day) Bottom">
					<AmChartSimpleBar
					 	chartId="utilisationunusedchart7"
					 	chartData={data7}
					 	categoryKey="label"
					 	valueKey="value"
					 	color={COLOR_UTILISATION_VACANT}
					 	width="100%"
					 	height="calc(100% - 0px)"
					/>
				</ChartCardLarge>														
			</div>  
			<DashboardToolPanel
				title="Choose Chart"
				actions={toolActions}
			/>
		</UtilityDashboardLayout>
			
	);
}